<template>
    <div class="activity-modal requisition input-full-width">
        <div class="modal-header">
            <h2 class="text-center">{{data.activityType}}</h2>
        </div>

        <div class="form">
            <div class="grid-x align-items">
                <div class="medium-1 small-2 cell flexbox-center">
                    <icon class="info small-svg" name="info" />
                </div>
                <div class="medium-3 small-5 cell" style="display: flex; align-items: center;">
                    <label for="">Bemærkning</label>
                </div>
                <div class="auto cell">
                    <p id="remark" style="white-space: pre; max-height: 250px; overflow-y: auto;" v-html="data.description"></p>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x align-items">
                <div class="medium-1 small-2 cell flexbox-center">
                    <icon class="bubble small-svg" name="bubble" />
                </div>
                <div class="medium-3 small-5 cell">
                    <label for="reportNote">Note</label>
                </div>
                <div class="auto cell">
                    <p id="reportNote">{{data.reportNote ? data.reportNote : 'Ingen note'}}</p>
                </div>
            </div>
        </div>
        <div class="grid-x" v-if="data.reference">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form" v-if="data.reference">
            <div class="grid-x align-items">
                <div class="large-1 medium-1 small-1 cell flexbox-center">
                    <icon class="dollar small-svg" name="dollar" />
                </div>
                <div class="large-3 medium-3 small-3 cell">
                    <label for="reference">Reference</label>
                </div>
                <div class="auto cell">
                    <p id="remark2">{{data.reference ? data.reference : 'Ingen reference'}}</p>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-naked" @click="closeModal()">Luk vindue</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'task-modal-requisition',
    props: {
        data: Object
    },
    methods: {
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/task/task-modal-requisition.vue